// extracted by mini-css-extract-plugin
module.exports = {"MenuGroup--max-height":"bfy_a"};